// extracted by mini-css-extract-plugin
export var arrowButtonV2 = "CarouselV2-module--arrowButtonV2--uJOLL";
export var arrowDisabledV2 = "CarouselV2-module--arrowDisabledV2--H-RFh";
export var authorIcon = "CarouselV2-module--authorIcon--AWNpK";
export var authorInfo = "CarouselV2-module--authorInfo--unkPv";
export var authorName = "CarouselV2-module--authorName---lqf7";
export var authorRole = "CarouselV2-module--authorRole--ErT6V";
export var carouselV2Arrows = "CarouselV2-module--carouselV2Arrows--3KyOS";
export var carouselV2Container = "CarouselV2-module--carouselV2Container--DdAT-";
export var carouselV2Controls = "CarouselV2-module--carouselV2Controls--dtEEz";
export var carouselV2Counter = "CarouselV2-module--carouselV2Counter--Kqgdx";
export var carouselV2Header = "CarouselV2-module--carouselV2Header--H-cQB";
export var carouselV2Heading = "CarouselV2-module--carouselV2Heading--W70Ip";
export var carouselV2Section = "CarouselV2-module--carouselV2Section--pihO5";
export var carouselV2Slide = "CarouselV2-module--carouselV2Slide--Zn1db";
export var carouselV2Subtitle = "CarouselV2-module--carouselV2Subtitle--wHYoX";
export var carouselV2Title = "CarouselV2-module--carouselV2Title--W+TVk";
export var carouselV2Track = "CarouselV2-module--carouselV2Track--3sYK9";
export var carouselV2Wrapper = "CarouselV2-module--carouselV2Wrapper--6Ilwp";
export var counterCurrent = "CarouselV2-module--counterCurrent--JJmzX";
export var counterSeparator = "CarouselV2-module--counterSeparator--dMXvf";
export var counterTotal = "CarouselV2-module--counterTotal--Agoqa";
export var fadeInV2 = "CarouselV2-module--fadeInV2--GFj69";
export var testimonialAuthor = "CarouselV2-module--testimonialAuthor--Y-nQr";
export var testimonialCard = "CarouselV2-module--testimonialCard--6CQV5";
export var testimonialQuote = "CarouselV2-module--testimonialQuote--vYUIT";